module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/d9a63b1ed1b24747b5e838dc776f5559.png";